// extracted by mini-css-extract-plugin
export default {"policyContainer":"PrivacyPolicy_policyContainer__2bqJ+","regulationContainer":"PrivacyPolicy_regulationContainer__dxR-i","policyText":"PrivacyPolicy_policyText__gPEIQ"};